import React, { useState, useEffect } from "react";
import Cart from "./components/Cart";
import Products from "./components/Products";
import logo from "./components/images/logo.png";
import filterList from "./components/FilterList";
import swal from '@sweetalert/with-react/';
import Footer from "./components/Footer";


function App() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    const productList = [...cart];

    if (!productList.includes(item)) {
      productList.push(item);
    }
    const index = productList.indexOf(item);
    productList[index].quantity++;
    setCart(productList);
    localStorage.setItem("cart", JSON.stringify(productList));
    swal({
      title: "Пицца добавлено!",
      icon: "success",
    });
  };

  const changeQuantity = (item, e) => {
    const productList = [...cart];
    const index = productList.indexOf(item);

    if (e === "+") {
      productList[index].quantity++;
    } else {
      if (productList[index].quantity > 1) {
        productList[index].quantity--;
      } else {
        productList.splice(index, 1);
      }
    }
    localStorage.setItem("cart", JSON.stringify(productList));
    setCart(productList);
  };

  useEffect(() => {
    setProducts(filterList([], null));
    JSON.parse(localStorage.getItem("cart")) &&
      setCart(JSON.parse(localStorage.getItem("cart")));
  }, []);

  return (
    <>
      <div className="header">
        <img src={logo} className="brand" alt="logo" />
        <Cart products={cart} changeQuantity={changeQuantity} />
      </div>
      <Products products={products} addToCart={addToCart} />
      <Footer />
    </>
  );
}

export default App;
